export default "__VITE_ASSET__COmpwlQk__"